module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAXklEQVRoge3PAQ2AMBDAwG3+Db4apoKQkjsF7Z6ZZ/3Y+TrgbQbrDNYZrDNYZ7DOYJ3BOoN1BusM1hmsM1hnsM5gncE6g3UG6wzWGawzWGewzmCdwTqDdQbrDNYZrLsnbQP62V6J+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/speakerOnly.png
// module id = qvKs
// module chunks = 0